export type MediaKind = 'image' | 'video';

const IMAGE_EXTENSIONS = new Set([
  'png',
  'jpg',
  'jpeg',
  'gif',
  'webp',
  'bmp',
  'ico',
  'avif',
  'heic',
  'heif'
]);

/** Human-readable lists for UI hints and documentation. */
export const SUPPORTED_IMAGE_EXTENSIONS_LABEL =
  'PNG, JPEG, GIF, WebP, BMP, ICO, AVIF, HEIC/HEIF';
export const SUPPORTED_VIDEO_EXTENSIONS_LABEL = 'MP4, WebM, MOV, M4V, OGV';

const VIDEO_EXTENSIONS = new Set(['mp4', 'webm', 'mov', 'm4v', 'ogv']);

export function fileExtension(fileName: string): string {
  const dot = fileName.lastIndexOf('.');
  if (dot < 0) return '';
  return fileName.slice(dot + 1).toLowerCase();
}

export function getMediaKind(fileName: string): MediaKind | null {
  const ext = fileExtension(fileName);
  if (IMAGE_EXTENSIONS.has(ext)) return 'image';
  if (VIDEO_EXTENSIONS.has(ext)) return 'video';
  return null;
}

export function isPreviewableMedia(fileName: string): boolean {
  return getMediaKind(fileName) !== null;
}

export function displayNameFromPath(path: string): string {
  const seg = path
    .replace(/\\/g, '/')
    .split('/')
    .filter(Boolean)
    .pop();
  return seg || path || 'File';
}
